/**
 * Vung tha tep + man hinh trong.
 *
 * Bat su kien keo tha o cap tai lieu chu khong o mot the div: nguoi dung tha
 * tep vao bat ky dau tren cua so cung phai an. Dem so lan dragenter/dragleave
 * de khong bi nhay khi con tro di qua cac phan tu con.
 */
import { useCallback, useEffect, useRef, useState } from 'react';

export interface DropZoneProps {
  onFile: (file: File) => void;
  /** Hien man hinh gioi thieu khi chua co tai lieu nao. */
  showEmptyState: boolean;
  coreLabel: string;
}

export function DropZone({ onFile, showEmptyState, coreLabel }: DropZoneProps) {
  const [dragging, setDragging] = useState(false);
  const depth = useRef(0);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const takeFile = useCallback(
    (list: FileList | null) => {
      const file = list?.[0];
      if (!file) return;
      onFile(file);
    },
    [onFile],
  );

  useEffect(() => {
    const onDragEnter = (e: DragEvent) => {
      if (!e.dataTransfer?.types.includes('Files')) return;
      e.preventDefault();
      depth.current += 1;
      setDragging(true);
    };
    const onDragOver = (e: DragEvent) => {
      if (!e.dataTransfer?.types.includes('Files')) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    };
    const onDragLeave = () => {
      depth.current = Math.max(0, depth.current - 1);
      if (depth.current === 0) setDragging(false);
    };
    const onDrop = (e: DragEvent) => {
      if (!e.dataTransfer) return;
      e.preventDefault();
      depth.current = 0;
      setDragging(false);
      takeFile(e.dataTransfer.files);
    };

    window.addEventListener('dragenter', onDragEnter);
    window.addEventListener('dragover', onDragOver);
    window.addEventListener('dragleave', onDragLeave);
    window.addEventListener('drop', onDrop);
    return () => {
      window.removeEventListener('dragenter', onDragEnter);
      window.removeEventListener('dragover', onDragOver);
      window.removeEventListener('dragleave', onDragLeave);
      window.removeEventListener('drop', onDrop);
    };
  }, [takeFile]);

  return (
    <>
      {showEmptyState && (
        <div className="emptyState">
          <div className="emptyCard">
            <div className="emptyGlyph" aria-hidden="true">
              <svg viewBox="0 0 64 80" width="64" height="80">
                <path
                  d="M8 4h32l16 16v56a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                />
                <path d="M40 4v16h16" fill="none" stroke="currentColor" strokeWidth="3" />
                <path d="M16 44h32M16 56h24" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              </svg>
            </div>
            <h1>Mở một tệp PDF để bắt đầu</h1>
            <p className="emptyLead">
              Kéo tệp thả vào đây, hoặc chọn từ máy. Tệp của bạn được xử lý ngay trong
              trình duyệt — không có gì được tải lên máy chủ.
            </p>
            <button type="button" className="button primary large" onClick={() => inputRef.current?.click()}>
              Chọn tệp PDF
            </button>
            <input
              ref={inputRef}
              type="file"
              accept="application/pdf,.pdf"
              hidden
              onChange={(e) => {
                takeFile(e.target.files);
                e.target.value = '';
              }}
            />
            <dl className="emptyFacts">
              <div>
                <dt>Lõi đang dùng</dt>
                <dd>{coreLabel}</dd>
              </div>
              <div>
                <dt>Tệp gốc</dt>
                <dd>Bất biến — mọi chỉnh sửa là một lớp lệnh đặt lên trên</dd>
              </div>
              <div>
                <dt>Lớp hiển thị</dt>
                <dd>Canvas · Văn bản DOM · SVG chú thích</dd>
              </div>
            </dl>
          </div>
        </div>
      )}

      {dragging && (
        <div className="dropOverlay" role="presentation">
          <div className="dropOverlayInner">
            <span className="dropIcon" aria-hidden="true">⤓</span>
            <span>Thả tệp PDF vào đây</span>
          </div>
        </div>
      )}
    </>
  );
}
